import React from 'react';
import fr from 'facet-rest';
import { navigateTo } from 'Helpers/Redirect';
import { loginPath } from 'Consts/Strings';
import PropTypes from 'prop-types';
import {
  FDSecondaryActionIconButton, FDStack, FDTitleText,
} from '@facet-wealth/design';

export const NavigateToLoginButton = ({ resource }) => {
  return resource.withRelationship(fr.relationships.login.name, (rel) => {
    return (
      <FDStack spacing={2} alignItems={'center'}>
        <FDSecondaryActionIconButton
          icon={'arrowLeft'}
          onClick={() => navigateTo(loginPath)}
          test={'back-to-login-btn'}
          label={rel.meta('title')}
        />
        <FDTitleText value={rel.meta('prompt')} color={'textSecondary'} />
      </FDStack>
    );
  }, () => null);
};

NavigateToLoginButton.propTypes = {
  resource: PropTypes.object.isRequired,
};
